import { render, staticRenderFns } from "./FUniswapWrapFTMConfirmation.vue?vue&type=template&id=1801e3b8&"
import script from "./FUniswapWrapFTMConfirmation.vue?vue&type=script&lang=js&"
export * from "./FUniswapWrapFTMConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports